'use client';

import { BookOpenCheck, Gamepad2, Award, Puzzle, Video, LineChart } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Reveal } from './reveal';

// Icon + i18n key per feature; copy lives in `public.features.items.<key>`.
const features = [
  { icon: BookOpenCheck, key: 'comprehension' },
  { icon: Gamepad2, key: 'gamified' },
  { icon: Award, key: 'milestones' },
  { icon: Puzzle, key: 'interactive' },
  { icon: Video, key: 'liveTeachers' },
  { icon: LineChart, key: 'parents' },
] as const;

export function FeaturesSection() {
  const t = useTranslations('public.features');
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4">
        <h2 className="font-display mb-12 text-center text-3xl font-bold text-eifo-primary md:text-4xl">
          {t('heading')}
        </h2>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, i) => (
            <Reveal key={feature.key} delayMs={(i % 3) * 90}>
              <div className="h-full rounded-xl border bg-white p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-eifo-orange/10">
                  <feature.icon className="h-6 w-6 text-eifo-orange" />
                </div>
                <h3 className="mb-2 text-lg font-semibold text-eifo-primary">
                  {t(`items.${feature.key}.title`)}
                </h3>
                <p className="text-sm text-gray-600">{t(`items.${feature.key}.description`)}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
